import axios from "axios";
import { ticketBaseURL } from "../configs/api";

export const getRdRentalInvoicesByTenantId = (tenantId: string, page: number, size: number) => {
    return getFetch(`rdRentalInvoice/GetRdRentalInvoicesPagingByTenantId/${tenantId},${page},${size}`)
}

export const getRdRentalInvoiceDetails = (invoiceId: string) => {
    return getFetch(`rdRentalInvoice/GetInvoiceDetails/${invoiceId}`)
}

const getFetch = (url: string, params = {}) => {
    return axios({
        url: ticketBaseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}